import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const CGVPage = () => {
  return (
    <div data-testid="cgv-page" className="min-h-screen bg-[#050505] pt-24 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Link */}
        <Link
          to="/"
          data-testid="cgv-back-link"
          className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#D4AF37] transition-colors mb-8"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="font-['Manrope'] text-sm">Retour à l'accueil</span>
        </Link>

        {/* Header */}
        <div className="mb-12">
          <h1 className="font-['Outfit'] text-3xl sm:text-4xl font-bold text-white mb-4">
            Conditions Générales de <span className="text-[#D4AF37]">Location</span>
          </h1>
          <p className="font-['Manrope'] text-[#A1A1AA]">
            SARL LUXEO CAR - 328 Boulevard Paul Raphel, 13730 Saint-Victoret
          </p>
          <p className="font-['Manrope'] text-[#52525B] text-sm mt-2">
            SIREN : 989 521 497 | SIRET : 989 521 497 00010 | RCS Aix-en-Provence | Capital : 5 000 €
          </p>
        </div>

        {/* Content */}
        <div className="card-luxeo p-8 sm:p-10 space-y-8">
          {/* Article 1 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 1 – OBJET DU CONTRAT
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Le présent contrat a pour objet la location par le Loueur au Client d'un véhicule automobile, 
              avec ses équipements et accessoires, destiné exclusivement à un usage professionnel de transport 
              de personnes à titre onéreux (VTC ou Taxi), dans les conditions définies ci-après.
            </p>
          </section>

          {/* Article 2 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 2 – DOCUMENTS CONTRACTUELS
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le contrat est composé des documents suivants :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>le présent Contrat de location</li>
              <li>les Conditions Particulières de Location</li>
              <li>l'état des lieux de départ et de restitution</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              En cas de contradiction, les Conditions Particulières prévalent.
            </p>
          </section>

          {/* Article 3 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 3 – DURÉE DE LA LOCATION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              La location est consentie sous la forme d'une location mensuelle, avec un paiement hebdomadaire.
              La durée minimale d'engagement est fixée à 6 mois calendaires, sauf stipulation contraire aux 
              Conditions Particulières. Le contrat prend effet à la date et à l'heure de remise du véhicule 
              et se renouvelle mensuellement sous réserve du respect des obligations contractuelles, notamment 
              le paiement intégral des loyers hebdomadaires. Le Loueur se réserve le droit de résilier le 
              contrat de plein droit en cas de défaut de paiement d'un loyer hebdomadaire.
            </p>
          </section>

          {/* Article 4 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 4 – VÉHICULE MIS À DISPOSITION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Le véhicule est remis au Client en parfait état de fonctionnement, sous réserve des défauts 
              non apparents. Un état des lieux contradictoire est réalisé lors de la remise du véhicule. 
              À défaut de réserve écrite du Client avant le départ, le véhicule est réputé conforme.
              Le véhicule demeure la propriété exclusive du Loueur ou de son financeur.
            </p>
          </section>

          {/* Article 5 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 5 – CONDITIONS POUR ÊTRE LOCATAIRE / CONDUCTEUR
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le Client déclare :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>être titulaire d'une carte professionnelle VTC ou d'une licence Taxi en cours de validité</li>
              <li>disposer d'un permis de conduire valide, non suspendu ni annulé</li>
              <li>être couvert par une assurance responsabilité civile professionnelle adaptée à son activité</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Le véhicule ne peut être conduit que par le Client ou les conducteurs expressément autorisés 
              par le Loueur. Toute sous-location ou prêt non autorisé est strictement interdit.
            </p>
          </section>

          {/* Article 6 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 6 – UTILISATION DU VÉHICULE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le Client s'engage à utiliser le véhicule :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>exclusivement dans le cadre de son activité VTC ou Taxi</li>
              <li>dans le respect du Code de la route et de la réglementation en vigueur</li>
              <li>avec soin, diligence et prudence</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Le kilométrage est illimité, sous réserve d'une utilisation normale et conforme à l'activité 
              de transport de personnes. Toute utilisation abusive, anormale ou manifestement excessive 
              pouvant entraîner une usure prématurée du véhicule pourra donner lieu à facturation complémentaire.
            </p>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3 mb-3">
              Sont strictement interdits :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>tout usage non professionnel ou illicite</li>
              <li>toute modification du véhicule</li>
              <li>toute compétition, essai ou usage non conforme</li>
              <li>la circulation hors des voies carrossables</li>
            </ul>
          </section>

          {/* Article 6 BIS */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 6 BIS – CLAUSE SÉCURITÉ & ANTI-FRAUDE VTC
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Afin de prévenir les risques d'impayés, de détournement ou d'utilisation frauduleuse du 
              véhicule, le Client reconnaît et accepte expressément que :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>le véhicule puisse être équipé d'un dispositif de géolocalisation et de télémétrie</li>
              <li>ces dispositifs puissent être utilisés uniquement à des fins de sécurité, de gestion du contrat et de récupération du véhicule</li>
              <li>en cas de défaut de paiement, d'usage non conforme, ou de suspicion légitime de fraude, 
                  le Loueur se réserve le droit de localiser le véhicule, d'en limiter l'usage et d'en 
                  organiser la reprise immédiate</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Toute tentative de dissimulation, neutralisation ou altération des dispositifs de sécurité 
              constitue un manquement grave entraînant la résiliation immédiate du contrat, sans préjudice 
              de poursuites civiles ou pénales.
            </p>
          </section>

          {/* Article 7 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 7 – ENTRETIEN ET OBLIGATIONS DU CLIENT
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le Client s'engage à :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>maintenir le véhicule en bon état</li>
              <li>vérifier régulièrement les niveaux</li>
              <li>signaler immédiatement toute anomalie</li>
              <li>respecter les échéances d'entretien communiquées par le Loueur</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Aucune réparation ne peut être engagée sans accord écrit préalable du Loueur.
            </p>
          </section>

          {/* Article 8 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 8 – RESTITUTION DU VÉHICULE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le véhicule doit être restitué à la date, au lieu et à l'heure convenus, dans l'état initial, 
              hors usure normale. Tout retard ou dégradation donnera lieu à facturation :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>frais de remise en état</li>
              <li>indemnité d'immobilisation</li>
              <li>frais de gestion</li>
            </ul>
          </section>

          {/* Article 9 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 9 – ASSURANCE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le véhicule est couvert par une assurance tous risques incluse, souscrite par le Loueur, comprenant :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>la responsabilité civile obligatoire</li>
              <li>les dommages tous accidents</li>
              <li>le vol et l'incendie</li>
              <li>la protection du conducteur</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Cette assurance est valable exclusivement dans le cadre d'une utilisation conforme au présent contrat.
              Une franchise contractuelle, dont le montant est précisé aux Conditions Particulières (généralement 300€ TTC), 
              reste à la charge du Client en cas de sinistre responsable ou sans tiers identifié.
              Toute exclusion de garantie ou déchéance résultant d'un manquement du Client lui sera intégralement refacturée.
            </p>
          </section>

          {/* Article 10 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 10 – RESPONSABILITÉ – DOMMAGES – VOL
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Conformément à l'article 1732 du Code civil, le Client est responsable de toute perte ou 
              dégradation, sauf force majeure dûment démontrée. En cas de vol ou de sinistre, le Client devra :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>informer immédiatement le Loueur</li>
              <li>déposer plainte</li>
              <li>fournir tout document nécessaire</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              À défaut, le Client perdra le bénéfice des éventuelles limitations de responsabilité.
            </p>
          </section>

          {/* Article 11 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 11 – PRIX – PAIEMENT – CAUTION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Le prix de la location est exprimé sur une base mensuelle, avec une facturation et un paiement 
              hebdomadaire d'avance. Tout loyer hebdomadaire impayé à échéance entraîne, après mise en demeure 
              restée infructueuse pendant 48 heures : la suspension immédiate du contrat, la reprise du véhicule 
              et la résiliation de plein droit aux torts exclusifs du Client. Une caution (généralement 500€ TTC) 
              est exigée lors de la remise du véhicule.
            </p>
          </section>

          {/* Article 12 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 12 – INFRACTIONS – PÉAGES – STATIONNEMENT
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Le Client est seul responsable des infractions, des amendes, des péages et redevances.
              Le Loueur est autorisé à transmettre l'identité du Client aux autorités compétentes et à 
              refacturer les frais de gestion.
            </p>
          </section>

          {/* Article 13 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 13 – RÉSILIATION ANTICIPÉE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Le contrat pourra être résilié de plein droit en cas de manquement grave du Client, notamment :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>non-paiement</li>
              <li>usage non conforme</li>
              <li>défaut d'assurance</li>
              <li>non-restitution du véhicule</li>
            </ul>
          </section>

          {/* Article 14 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 14 – DONNÉES PERSONNELLES
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Les données personnelles sont traitées conformément à la réglementation RGPD, exclusivement 
              pour l'exécution du contrat. Pour plus d'informations, consultez notre politique de confidentialité.
            </p>
          </section>

          {/* Article 15 */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              ARTICLE 15 – DROIT APPLICABLE – JURIDICTION
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed">
              Le présent contrat est soumis au droit français. Tout litige opposant des professionnels 
              relèvera de la compétence exclusive du Tribunal de commerce d'Aix-en-Provence.
            </p>
          </section>

          {/* Conditions Véhicule Électrique */}
          <section className="pt-8 border-t border-white/10">
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#D4AF37] mb-4">
              CONDITIONS SPÉCIFIQUES VÉHICULE ÉLECTRIQUE
            </h2>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mb-3">
              Pour les véhicules électriques (Tesla Model Y, Ford Mustang Mach-E), le Client s'engage à :
            </p>
            <ul className="list-disc list-inside font-['Manrope'] text-[#A1A1AA] text-sm space-y-1 ml-4">
              <li>restituer le véhicule avec un niveau de charge équivalent à celui de la remise</li>
              <li>utiliser exclusivement les équipements de recharge conformes</li>
              <li>restituer le câble de recharge d'origine</li>
            </ul>
            <p className="font-['Manrope'] text-[#A1A1AA] text-sm leading-relaxed mt-3">
              Toute dégradation de la batterie, du câble ou des équipements de recharge sera facturée au Client.
            </p>
          </section>

          {/* Contact */}
          <section className="pt-8 border-t border-white/10">
            <h2 className="font-['Outfit'] text-xl font-semibold text-white mb-4">
              Contact
            </h2>
            <div className="font-['Manrope'] text-[#A1A1AA] text-sm space-y-1">
              <p><strong>SARL LUXEO CAR</strong></p>
              <p>328 Boulevard Paul Raphel</p>
              <p>13730 Saint-Victoret</p>
              <p>Tél : <a href="tel:0620202996" className="text-[#D4AF37] hover:underline">06 20 20 29 96</a></p>
              <p>Email : <a href="mailto:luxeocar@gmail.com" className="text-[#D4AF37] hover:underline">luxeocar@gmail.com</a></p>
              <p>SIREN : 989 521 497</p>
              <p>SIRET : 989 521 497 00010</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
